<script setup lang="ts">
import type { ManagedContent } from '@/types/directus-types/directus_types';
import WizardDontShowAgainBtn from './WizardDontShowAgainBtn.vue';

const { data, fallbackTitle } = defineProps<{ data: ManagedContent | undefined, fallbackTitle: string }>()

</script>
<template>
  <v-card flat>
    <v-card-title> {{ data ? data.Name : fallbackTitle }} </v-card-title>
    <v-card-text>
      <div v-if="data" v-html="data.Content"></div>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <WizardDontShowAgainBtn />
    </v-card-actions>
  </v-card>
</template>

